//#region DevExtreme Imports

import { StateService } from "@uirouter/angularjs"

//#endregion

//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { Api, LocalDictionaryFactory } from './../api/api.module'
import { ColumnModel } from '../api/api.models'

import { BaseGridGridsterController, ScopeBaseGridsterGrid } from '../common/common.base.grid.gridster.controller'
import { GridTypes, ButtonsOptions, GridController } from '../common/grid/grid.controller'
import { LoggerService } from './../common/common.module'
import { MapOptions, MapLegendItem } from '../common/map2/map.directive.controller'

import { CommonHelper, EventsNames, LocalizationHelper, MapHelper, TypeHelper } from '../../helpers/'
import { DepositoryService } from '../../services/depository'

import { Activity, Enums } from '../../models/common/'
import { OpBounds } from '../../models/custom/op-map-area'
import { OpLocation, OpLocationEquipment } from '../../models/core/'

import { DepositoryHelper } from './depositories.helper'
import { UserSessionService } from '../../services/user-session'
import { FilterNames } from '../../helpers/common-helper';
import { ItemSwapperPopupOptions, IItemSwapperPopup, ItemSwapperResult } from '../../modules/common/item-swapper/'
import { CreateEditResult, DetailsResult, SystemService } from '../../services/system'
import { GridContextMenuService } from "../../services/grid"
import { ColumnInfo } from "../../../app/models/custom"

export interface DepositoryScope extends ScopeBaseGridsterGrid {

    itemSwapperPopupOptions: ItemSwapperPopupOptions<OpLocationEquipment>

    deleteConfirmationOptions: {
        title: string

        onConfirmed: () => void
    }
}

export class DepositoryController extends BaseGridGridsterController {

    // #region Members

    private grid: GridController<OpLocation>
    private itemSwapperPopup: IItemSwapperPopup<OpLocationEquipment>

    // #endregion


    constructor(
        protected $scope: DepositoryScope,
        $state: StateService,
        $timeout: ng.ITimeoutService,
        api: Api,
        private logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        private gridContextMenuService: GridContextMenuService,
        protected userSession: UserSessionService,
        private depositoryService: DepositoryService,
        protected systemService: SystemService,
        referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super($scope, $timeout, $state, userSession, systemService, api, localDictionary, null, null, Enums.SimaxModuleName[moduleName], referenceType, true)

        this.setConfirmationsOptions()
        this.setEvents()
        this.setMainGridOptions()
        this.initializeItemSwapper()
    }


    // #region Events

    private onInitialized(e: any, grid: GridController<OpLocation>): void {
        this.dataGrid = e.component
        this.grid = grid

        this.setGridId(e.tableId)
        this.onGridInit(e.tableId)
    }

    private onAdd(): void {
        this.depositoryService
            .openCreate()
            .then((result: CreateEditResult<OpLocation>) => {
                if (result.status === CreateEditResult.Status.Success) {
                    this.onSaved();
                }
            });
    }

    private onEdit(): void {
        if (this.dataGrid.getSelectedRowKeys().length == 1) {
            this.depositoryService
                .openEdit(this.grid.selectedItemId)
                .then((result: CreateEditResult<OpLocation>) => {
                    if (result.status === CreateEditResult.Status.Success) {
                        this.onSaved();
                    }
                });
        } else {
            const columnCount = this.dataGrid.columnCount()
            const columns = []

            for (let i = 0; i < columnCount; i++) {
                columns.push(this.dataGrid.columnOption(i));
            }

            this.depositoryService
                .openBulkEdit(columns, this.grid.selectedGridItems)
                .then((result: CreateEditResult<OpLocation>) => {
                    if (result.status === CreateEditResult.Status.Success || result.status === CreateEditResult.Status.Error) {
                        this.onSaved();
                    }
                });
        }
    }

    private onShowDetails(e: any): void {
        this.depositoryService
            .openDetails(this.grid.selectedItemId, this.grid.pageItemsIds)
            .then((result: DetailsResult) => {
                if (result.status === DetailsResult.Status.Deleted || result.status === DetailsResult.Status.Edited) {
                    this.grid.refresh();
                }
            });
    }

    private onDelete(): void {
        this.$scope.$broadcast(
            EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.popupId,
            LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONFIRM_DELETE, this.moduleName)
        )
    }

    private onDeleted(): void {
        this.grid.refresh()
    }

    private onConfirmDelete(): void {
        DepositoryHelper
            .deleteDepository(this.userSession.getDataProvider(), this.grid.selectedItemId)
            .then(() => {
                this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName))
            })
            .fail((error: any) => {
                this.logger.log(error)
            })
    }

    private onSaved(): void {
        this.grid.refresh();
    }

    // #endregion


    // #region Rewarehousing    

    private openRewarehousingItemSwapper(): void {
        this.itemSwapperPopup.itemSwapper.reset()
        this.itemSwapperPopup.show()
    }

    private initializeItemSwapper(): void {
        this.depositoryService
            .getDefaultRewarehousingItemSwapperOptions()
            .then((options: ItemSwapperPopupOptions<OpLocationEquipment>) => {
                options.onSave = (result: ItemSwapperResult<OpLocationEquipment>) => this.onRewarehousingSave(result)

                options.itemSwapperOptions.leftGridOptions.getDataSourceFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
                    if (this.grid != null
                        && this.grid.selectedItem != null
                        && this.itemSwapperPopup != null
                        && this.itemSwapperPopup.isVisible()
                    ) {
                        return this.userSession
                            .getDataProvider()
                            .Depository
                            .getDepositoryContentFilter(this.grid.selectedItemId, columns, pageNbr, pageSize, customWhereClause)
                    }

                    return $.Deferred<any>().resolve(TypeHelper.NullObjectListResult).promise()
                }

                options.itemSwapperOptions.rightSelectGridOptions.getSelectedItemDataSourceFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string, idDepository: number) => {
                    if (this.grid != null
                        && this.grid.selectedItem != null
                        && this.itemSwapperPopup != null
                        && this.itemSwapperPopup.isVisible()
                    ) {
                        return this.userSession
                            .getDataProvider()
                            .Depository
                            .getDepositoryContentFilter(idDepository, columns, pageNbr, pageSize, customWhereClause)
                    }

                    return $.Deferred<any>().resolve(TypeHelper.NullObjectListResult).promise()
                }

                this.$scope.itemSwapperPopupOptions = options
                this.$scope.itemSwapperPopupOptions.onInitialized = (itemSwapper: IItemSwapperPopup<OpLocationEquipment>) => {
                    this.itemSwapperPopup = itemSwapper
                }
            })
    }

    private onRewarehousingSave(result: ItemSwapperResult<OpLocationEquipment>): JQueryPromise<void> {
        return this.depositoryService
            .saveDepositoryEquipment(this.grid.selectedItemId, result)
            .fail((error: any) => {
                this.logger.log(error)
            })
            .always(() => {
                this.grid.dxGrid.refresh()
            })
    }

    // #endregion


    // #region Setup

    private getContextMenuItems(isTouchScreen: boolean = false): any[] {
        const items = this.gridContextMenuService.getContextMenuItems(Enums.SimaxModuleName.Depository, {
            idReferenceTypes: this.grid.selectedItemsIds,

            onEdit: () => {
                this.onEdit()
            },

            onContentEdit: () => {
                this.itemSwapperPopup ? this.openRewarehousingItemSwapper() : this.initializeItemSwapper()
            },

            getCorrespondingActionType: (idReferenceType: Enums.ReferenceType, e: any) => {
                this.getCorrespondingActionType(idReferenceType, e)
            }
        })

        return this.mergeWithDefaultItems(isTouchScreen, items)
    }

    private getGridDataSourceParser(): any {
        return (location: OpLocation) => {
            return {
                additionalFields: [{
                    key: MapHelper.LatitudeFieldName,
                    value: location.latitude
                }, {
                    key: MapHelper.LongitudeFieldName,
                    value: location.longitude
                }]
            }
        }
    }

    private getGridButtonsOptions(): ButtonsOptions {
        return {
            enabled: true,

            addPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.DEPOSITORY_ADD) ? "['" + Activity[Activity.DEPOSITORY_ADD] + "']" : null,
            deletePermissions: this.userSession.getLoggedOperator().hasPermission(Activity.DEPOSITORY_DEL) ? "['" + Activity[Activity.DEPOSITORY_DEL] + "']" : null,
            depositoryContentEditPermission: this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_FITTER_DEPOSITORY_EDIT) ? "['" + Activity[Activity.OPERATOR_FITTER_DEPOSITORY_EDIT] + "']" : null,
            editPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.DEPOSITORY_EDIT) ? "['" + Activity[Activity.DEPOSITORY_EDIT] + "']" : null,
            saveColumnSettingsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP) ? "['" + Activity[Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP] + "']" : null,
            showDetailsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.DEPOSITORY_LIST) ? "['" + Activity[Activity.DEPOSITORY_LIST] + "']" : null,

            onAddClick: () => this.onAdd(),
            onDeleteClick: () => this.onDelete(),
            onDepositryContentEdit: () => this.openRewarehousingItemSwapper(),
            onEditClick: () => this.onEdit(),
            onShowClick: (e: any) => this.onShowDetails(e),
            onShowMap: () => this.showMapDetails()
        }
    }

    private setConfirmationsOptions(): void {
        this.$scope.deleteConfirmationOptions = {
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),

            onConfirmed: () => this.onConfirmDelete()
        }
    }

    private setEvents() {
        this.$scope.$on(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName), (event: ng.IAngularEvent, ...args: any[]) => this.onDeleted())
        this.$scope.showDetails = (e: any) => this.onShowDetails(e)
    }

    private setMainGridOptions() {
        $.when(
            this.userSession
                .getDataProvider().System
                .getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS, this.moduleName),
            this.userSession
                .getDataProvider().System
                .getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__DEFAULT_GRID_PARAMS, this.moduleName)
        )
            .then((columns: ColumnModel[], defaultColumns: ColumnModel[]) => {
                // If you'll ever add export options here, use this.userSession.getDataProvider().Depository.depositoryExport
                this.$scope.mainGridOptions = {
                    addCustomFilters: true,
                    buttonsOptions: this.getGridButtonsOptions(),
                    columnsDictionary: columns,
                    dataSourceParser: this.getGridDataSourceParser(),
                    defaultColumnsDictionary: defaultColumns,
                    exportMethod: 'locations',
                    getDataSourceMethod: this.userSession.getDataProvider().Depository.getDepositoryFilter,
                    idReferenceType: this.referenceType,
                    name: 'DepositoriesGrid',
                    preExecuteClearFilter: this.preExecuteGridClearFilter,
                    referenceId: this.referenceType,
                    type: GridTypes.MAIN,

                    allowColumnReordering: !this.userSession
                        .getLoggedOperator()
                        .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.DepositoryModuleMainGrid),

                    contextMenuItems: (isTouchScreen: boolean = false) => this.getContextMenuItems(isTouchScreen),
                    onDataReady: (data: any) => this.onDataReady(data),
                    onInitialized: (e: any, grid: GridController<OpLocation>) => this.onInitialized(e, grid),
                    onRowDoubleClick: (e: any) => this.onShowDetails(e),
                    onSelectionChanged: (e: any) => this.onSelectionChanged(e),
                    onUpdateGridsterPosition: (e: any) => this.setGridsterPosition(e),
                }
            })
    }

    // #endregion


    // #region BaseGridGridsterController Implementation

    protected onGridsterMapConfiguration(mapOptions: MapOptions): void {
        mapOptions.enableAreaSelect = true

        mapOptions.onAreaSelect = (bounds: OpBounds) => {
            MapHelper
                .getCoordColumnNames(this.userSession.getDataProvider())
                .then(([latColName, lonColName]: [string, string]) => {
                    this.addCustomGridFilter(CommonHelper.getLonLatFilter(bounds, latColName, lonColName, FilterNames.DepositoriesByMarkers))
                })
        }

        MapHelper
            .getLegendItems(this.userSession.getDataProvider(), Enums.ReferenceType.IdLocation)
            .then((items: MapLegendItem[]) => {
                mapOptions.legendItems = items
            })
    }

    // #endregion
}